<template>
  <v-menu offset-y offset-x left nudge-right="45" :close-on-content-click="closeOnContentClick">
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator" v-bind="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" :color="color">
          <v-icon :small="small">{{ icon }}</v-icon>
        </v-btn>
      </slot>
    </template>
    <v-card>
      <v-card-text class="pa-0">
        <slot />
      </v-card-text>
    </v-card>
  </v-menu>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class ContextMenu extends Vue {
  @Prop({ default: "mdi-dots-vertical" })
  icon?: string;

  @Prop({ default: "" })
  color?: string;

  @Prop({ default: false })
  small?: boolean;

  @Prop({ default: false })
  closeOnContentClick?: boolean;
}
</script>
